import type { Protocol } from '@zyxantech/wiz'

/** wiz Protocol union members, for validating a raw protocol string. */
const WIZ_PROTOCOLS: readonly Protocol[] = [
  'modbus-tcp',
  'modbus-rtu',
  'opc-ua',
  'mqtt',
  'lorawan',
  'bacnet',
  'profinet',
  'ethernet-ip',
  'rest-api',
  'sql-server',
  'postgresql',
  'file',
]

/** StatusLight status set (wiz) — distinct from the API's gateway status. */
export type LightStatus = 'running' | 'idle' | 'error' | 'offline' | 'warning'

/** Map the API gateway status to a wiz StatusLight status. */
export function gatewayLightStatus(status: string): LightStatus {
  if (status === 'online') return 'running'
  if (status === 'error') return 'error'
  return 'offline'
}

/**
 * Extract a wiz-compatible Protocol from a gateway's protocolConfig blob, if it
 * names a known protocol. protocolConfig is an untyped object on the API.
 */
export function gatewayProtocol(protocolConfig: unknown): Protocol | null {
  if (typeof protocolConfig !== 'object' || protocolConfig === null) return null
  const raw = (protocolConfig as Record<string, unknown>).protocol
  if (typeof raw !== 'string') return null
  const normalized = raw.toLowerCase().replace(/[_\s]/g, '-')
  return WIZ_PROTOCOLS.includes(normalized as Protocol) ? (normalized as Protocol) : null
}

/** Human-readable endpoint (host:port) from protocolConfig, if present. */
export function gatewayEndpoint(protocolConfig: unknown): string | null {
  if (typeof protocolConfig !== 'object' || protocolConfig === null) return null
  const cfg = protocolConfig as Record<string, unknown>
  const host = cfg.host ?? cfg.ip ?? cfg.address
  const port = cfg.port
  if (typeof host !== 'string') return null
  return typeof port === 'number' ? `${host}:${port}` : host
}
